/*eslint-disable */
import { createRouter, createWebHistory } from "vue-router";

const basePath = [
	{
		path: '/404',
		component: () => import(/* webpackChunkName: "404" */ '@/components/page/404.vue'),
		meta: {title: '404'}
	},
	{
		path: '/403',
		component: () => import(/* webpackChunkName: "403" */ '@/components/page/403.vue'),
		meta: {title: '403'}
	},
	{
		path: '/:pathMatch(.*)',
		redirect: '/404'
	},
];

const getChunks = (modulesContext) => {
	if (!modulesContext || modulesContext.length === 0) {
		return undefined;
	}
	return modulesContext.keys().reduce((modules, key) => {
		modules[key.replace(/(^\.\/)|(\.js$)/g, '')] = modulesContext(key).default
		return modules;
	}, {});
}


const config = require('../../config/projectsConfig.js')
// 获取package.json中scripts配置的变量
let projectName = process.env.VUE_APP_PROJECT_NAME
let routes = new Set([...basePath]);

const routerContext = require.context('./modules', true, /\.js$/)
const routerChunks = getChunks(routerContext)
Object.keys(routerChunks).forEach((item) => {
	let paths = routerChunks[item];
	if (config[projectName].router && config[projectName].router !== item) {
		paths = [];
	}
	Object.keys(paths).forEach(index => {
		routes.add(paths[index]);
	});
})

let routerPath = process.env.VUE_APP_ROUTER_BASE
let paths = routerPath.split('_')
const base = process.env.NODE_ENV === 'production' ? `/${paths.join('/')}` : ''
const router = createRouter({
	history: createWebHistory(base),
	routes,
});
export default router;